/**
 * The SHA-256 of a file's bytes, as lowercase hex - the same fingerprint the
 * server records on every upload (`UserUploadedFile.content_sha256`), taken
 * before anything is sent so a copy of a photo the record already holds never
 * travels again (WPS-223).
 *
 * Null when the browser cannot hash here (no `crypto.subtle` outside a secure
 * context) or the file is too large to read into memory comfortably; the
 * server still checks such a file when it arrives.
 */

/** Larger files are not hashed in the browser - Web Crypto has no streaming digest. */
export const MAX_HASH_BYTES = 256 * 1024 * 1024

export async function sha256OfFile(file: File): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle
  if (!subtle || file.size > MAX_HASH_BYTES) return null
  try {
    const digest = await subtle.digest('SHA-256', await file.arrayBuffer())
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join(
      '',
    )
  } catch {
    return null
  }
}
